//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '3.8.2'.
//
package de.katoonerie

import com.apollographql.apollo3.annotations.ApolloAdaptableWith
import com.apollographql.apollo3.api.Adapter
import com.apollographql.apollo3.api.CompiledField
import com.apollographql.apollo3.api.CustomScalarAdapters
import com.apollographql.apollo3.api.Optional
import com.apollographql.apollo3.api.Query
import com.apollographql.apollo3.api.json.JsonWriter
import com.apollographql.apollo3.api.obj
import de.katoonerie.adapter.PageQuery_ResponseAdapter
import de.katoonerie.adapter.PageQuery_VariablesAdapter
import de.katoonerie.selections.PageQuerySelections
import kotlin.Any
import kotlin.Boolean
import kotlin.String
import kotlin.Unit
import kotlin.collections.List

public data class PageQuery(
  public val preview: Optional<Boolean?> = Optional.Absent,
  public val url: String,
) : Query<PageQuery.Data> {
  public override fun id(): String = OPERATION_ID

  public override fun document(): String = OPERATION_DOCUMENT

  public override fun name(): String = OPERATION_NAME

  public override fun serializeVariables(writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters): Unit {
    PageQuery_VariablesAdapter.toJson(writer, customScalarAdapters, this)
  }

  public override fun adapter(): Adapter<Data> = PageQuery_ResponseAdapter.Data.obj()

  public override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = de.katoonerie.type.Query.type
  )
  .selections(selections = PageQuerySelections.__root)
  .build()

  @ApolloAdaptableWith(PageQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val pageCollection: PageCollection?,
  ) : Query.Data

  public data class PageCollection(
    public val items: List<Item?>,
  ) {
    public fun itemsFilterNotNull(): List<Item> = items.filterNotNull()
  }

  public data class Item(
    public val name: String?,
    public val url: String?,
    public val navigationBar: NavigationBar?,
    public val tilesCollection: TilesCollection?,
  )

  public data class NavigationBar(
    public val navigationItemsCollection: NavigationItemsCollection?,
  )

  public data class NavigationItemsCollection(
    public val items: List<Item1?>,
  ) {
    public fun itemsFilterNotNull(): List<Item1> = items.filterNotNull()
  }

  public data class Item1(
    public val tile: Tile?,
    public val color: Color?,
    public val icon: Icon?,
  )

  public data class Tile(
    public val name: String?,
    public val slug: String?,
  )

  public data class Color(
    public val hex: String?,
  )

  public data class Icon(
    public val url: String?,
  )

  public data class TilesCollection(
    public val items: List<Item2?>,
  ) {
    public fun itemsFilterNotNull(): List<Item2> = items.filterNotNull()
  }

  public data class Item2(
    public val name: String?,
    public val slug: String?,
    public val color: Color1?,
    public val layout: Layout?,
    public val media: Media?,
    public val body: Body?,
    public val gimmicksCollection: GimmicksCollection?,
  )

  public data class Color1(
    public val hex: String?,
  )

  public data class Layout(
    public val type: String?,
  )

  public data class Media(
    public val youTubeVideosCollection: YouTubeVideosCollection?,
    public val mediaCollection: MediaCollection?,
  )

  public data class YouTubeVideosCollection(
    public val items: List<Item3?>,
  ) {
    public fun itemsFilterNotNull(): List<Item3> = items.filterNotNull()
  }

  public data class Item3(
    public val name: String?,
    public val videoId: String?,
  )

  public data class MediaCollection(
    public val items: List<Item4?>,
  ) {
    public fun itemsFilterNotNull(): List<Item4> = items.filterNotNull()
  }

  public data class Item4(
    public val contentType: String?,
    public val title: String?,
    public val url: String?,
  )

  public data class Body(
    public val mediaCollection: MediaCollection1?,
    public val textColor: TextColor?,
    public val backgroundColor: BackgroundColor?,
    public val borderColor: BorderColor?,
    public val text: Text?,
  )

  public data class MediaCollection1(
    public val items: List<Item5?>,
  ) {
    public fun itemsFilterNotNull(): List<Item5> = items.filterNotNull()
  }

  public data class Item5(
    public val contentType: String?,
    public val title: String?,
    public val url: String?,
  )

  public data class TextColor(
    public val hex: String?,
  )

  public data class BackgroundColor(
    public val hex: String?,
  )

  public data class BorderColor(
    public val hex: String?,
  )

  public data class Text(
    public val json: Any,
  )

  public data class GimmicksCollection(
    public val items: List<Item6?>,
  ) {
    public fun itemsFilterNotNull(): List<Item6> = items.filterNotNull()
  }

  public data class Item6(
    public val image: Image?,
    public val position: Position?,
  )

  public data class Image(
    public val title: String?,
    public val url: String?,
  )

  public data class Position(
    public val type: String?,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "20d65fdb6c98d6c8c8dde577a2121541d5aaa4c2657f8071f6e620e3bd22e6f0"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * query Page($preview: Boolean, $url: String!) {
     *   pageCollection(preview: $preview, where: {
     *     url: $url
     *   }
     *   , limit: 1) {
     *     items {
     *       name
     *       url
     *       navigationBar {
     *         navigationItemsCollection(limit: 11) {
     *           items {
     *             tile {
     *               name
     *               slug
     *             }
     *             color {
     *               hex
     *             }
     *             icon {
     *               url(transform: {
     *                 width: 100
     *                 height: 100
     *                 resizeStrategy: FIT
     *               }
     *               )
     *             }
     *           }
     *         }
     *       }
     *       tilesCollection(limit: 15) {
     *         items {
     *           name
     *           slug
     *           color {
     *             hex
     *           }
     *           layout {
     *             type
     *           }
     *           media {
     *             youTubeVideosCollection(limit: 8) {
     *               items {
     *                 name
     *                 videoId
     *               }
     *             }
     *             mediaCollection(limit: 8) {
     *               items {
     *                 contentType
     *                 title
     *                 url(transform: {
     *                   width: 520
     *                   format: PNG
     *                 }
     *                 )
     *               }
     *             }
     *           }
     *           body {
     *             mediaCollection(limit: 8) {
     *               items {
     *                 contentType
     *                 title
     *                 url(transform: {
     *                   width: 520
     *                   format: PNG
     *                 }
     *                 )
     *               }
     *             }
     *             textColor {
     *               hex
     *             }
     *             backgroundColor {
     *               hex
     *             }
     *             borderColor {
     *               hex
     *             }
     *             text {
     *               json
     *             }
     *           }
     *           gimmicksCollection(limit: 3) {
     *             items {
     *               image {
     *                 title
     *                 url(transform: {
     *                   width: 160
     *                   height: 160
     *                   format: PNG
     *                 }
     *                 )
     *               }
     *               position {
     *                 type
     *               }
     *             }
     *           }
     *         }
     *       }
     *     }
     *   }
     * }
     */
    public val OPERATION_DOCUMENT: String
      get() =
          "query Page(${'$'}preview: Boolean, ${'$'}url: String!) { pageCollection(preview: ${'$'}preview, where: { url: ${'$'}url } , limit: 1) { items { name url navigationBar { navigationItemsCollection(limit: 11) { items { tile { name slug } color { hex } icon { url(transform: { width: 100 height: 100 resizeStrategy: FIT } ) } } } } tilesCollection(limit: 15) { items { name slug color { hex } layout { type } media { youTubeVideosCollection(limit: 8) { items { name videoId } } mediaCollection(limit: 8) { items { contentType title url(transform: { width: 520 format: PNG } ) } } } body { mediaCollection(limit: 8) { items { contentType title url(transform: { width: 520 format: PNG } ) } } textColor { hex } backgroundColor { hex } borderColor { hex } text { json } } gimmicksCollection(limit: 3) { items { image { title url(transform: { width: 160 height: 160 format: PNG } ) } position { type } } } } } } } }"

    public const val OPERATION_NAME: String = "Page"
  }
}
